import { render, staticRenderFns } from "./CatalogIndex.vue?vue&type=template&id=db1ca650&"
import script from "./CatalogIndex.vue?vue&type=script&lang=js&"
export * from "./CatalogIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports